import React, { useEffect } from 'react';
import VerticalLinearStepper from '../../components/common/Stepper';
import HorizontalLinearStepper from '../../components/HorizontalStepper';
import Box from '@mui/material/Box';
import { Grid, Typography } from '@mui/material';
import { useState } from 'react';
import './CreateSession.scss';
import CreateSessionForm from '../../components/CreateSession/CreateSessionForm';
import ScheduleTraining from '../../components/CreateSession/ScheduleTraining';
import SystemSpecification from '../../components/CreateSession/SystemSpecification';
import BrowseStudent from '../../components/CreateSession/BrowseStudent';
import { useLocation } from 'react-router-dom';
import { disabled } from 'glamor';
import { useDispatch, useSelector } from 'react-redux';
import { TrainingList } from '../../redux/features/CreateSession';
import {
	sessionDetails,
	scheduleTraining,
	systemSpecification,
	studentDetails,
	cloudType,
} from '../../redux/features/CreateSessionReducer';
import { Stack } from 'immutable';

function CreateSession() {
	const { state } = useLocation();
	const dispatch = useDispatch();
	const [startDate, setStartDate] = useState(new Date());
	const [steps, setsteps] = useState([
		{
			label: 'Step1',
			description: 'Session Details',
		},

		{
			label: 'Step2',
			description: 'Schedule Training',
		},
		{
			label: 'Step3',
			description: 'System Specification and Training Center Details',
		},
		{
			label: 'Step4',
			description: 'Student Details',
		},
	]);
	const [selectedTraining, setSelectedTraining] = useState('');
	const [trainingVal, setTrainingVal] = useState();
	const [activeStep, setActiveStep] = React.useState(0);

	const handleNext = (data) => {
		setActiveStep((prevActiveStep) => prevActiveStep + 1);
		setSelectedTraining(data);
	};

	const handleBack = () => {
		setActiveStep((prevActiveStep) => prevActiveStep - 1);
	};
	const trainingDetails = useSelector((state) => {
		return state?.TrainingById;
	});
	useEffect(() => {
		if (state?.action === 'reschedule' || state?.action === 'copy') {
			getTrainingData();
		}
	}, [trainingDetails?.TrainingById]);
	const getTrainingData = () => {
		if (trainingDetails?.loading) {
		} else {
			let data = trainingDetails?.TrainingById?.data?.data;
			dispatch(
				sessionDetails({
					title: '',
					tags: data?.tags,
					host: data?.host,
					feedback_template_id: data?.feedback_template_id,
					description: data?.description,
					is_private: data?.is_private,
				})
			);
			dispatch(
				cloudType({
					sessionType:
						data?.cloud_type === 'GCP' ? 'longtermsession' : 'training',
					gcpType:
						data?.cloud_type === 'GCP'
							? data?.immediate_launch === true
								? 'Right Now'
								: 'Schedule'
							: '',
				})
			);
			dispatch(
				systemSpecification({
					zone: data?.zone,
					region_code: data?.region_code,
					machine_ami_id: data?.machine_ami_id,
					instance_id: data?.instance_id,
					instructor_id: data?.instructor_id,
					studio_id: data?.studio_id,
				})
			);
			let studentData = data?.users_trainings.map((item) => {
				return {
					is_machine_required: item.is_machine_required,
					email_id: item.student.email_id,
					contact_no: item.student.contact_no,
					name: item.student.name,
					short_information: item.student.short_information,
					country_name: item.student.country_name,
					location: item.student?.location?.code ? item.student?.location?.code : "",
				};
			});
			console.log('check student data ----', studentData);
			dispatch(
				studentDetails({
					student: studentData,
				})
			);
		}
	};
	useEffect(() => {
		console.log('state>>>', trainingDetails);
		if (state?.action === 'reschedule') {
			setActiveStep(1);
		} else if (state?.action === 'copy') {
			let params = {
				tid: state.training,
			};
			dispatch(
				TrainingList({
					params,
				})
			);
			setActiveStep(0);
		}
	}, []);
	useEffect(() => {
		console.log('window', window.location.pathname);

		if (window.location.pathname === '/createsession') {
			dispatch(scheduleTraining({}));

			dispatch(systemSpecification({}));

			dispatch(sessionDetails({}));
			dispatch(studentDetails({}));
			dispatch(cloudType({}));
		}
	}, [window.location.pathname]);
	const renderSteps = () => {
		if (activeStep === 0) {
			return (
				<CreateSessionForm
					handleNext={handleNext}
					handleBack={handleBack}
					action={state?.action ? state?.action : ''}
				/>
			);
		} else if (activeStep === 1) {
			return (
				<ScheduleTraining
					handleNext={handleNext}
					handleBack={handleBack}
					training={state?.training}
					selectedOption={selectedTraining}
					trainingData={trainingVal}
					action={state?.action ? state?.action : ''}
				/>
			);
		} else if (activeStep === 2) {
			return (
				<SystemSpecification
					handleNext={handleNext}
					handleBack={handleBack}
					action={state?.action ? state?.action : ''}
				/>
			);
		} else if (activeStep === 3) {
			return (
				<BrowseStudent
					handleNext={handleNext}
					handleBack={handleBack}
					action={state?.action ? state?.action : ''}
				/>
			);
		}
	};
	return (
		<>
			<Box className="mainCont">
				{/* <Typography className="image_heading">Create Session</Typography> */}
				<span className="larger_f_bold marginSets">Create Session</span>
				<Grid container spacing={1} marginTop="1%">
					<Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
						<div
							className={
								window.innerWidth > 768
									? 'step-cont'
									: 'step-cont-create-smallscreen'
							}
						>
							{/* <VerticalLinearStepper steps={steps} activeStep={activeStep} /> */}
							{window.innerWidth > 768 ? (
								<VerticalLinearStepper steps={steps} activeStep={activeStep} />
							) : (
								<HorizontalLinearStepper
									steps={steps}
									activeStep={activeStep}
									page={'createsession'}
								/>
							)}
						</div>
					</Grid>
					<Grid item xs={12} sm={12} md={9} lg={9} xl={9}>
						<div className="step-cont LeftPadding">{renderSteps()}</div>
					</Grid>
				</Grid>
			</Box>
		</>
	);
}

export default CreateSession;
